import React from "react"
import styled from "styled-components"

const StyledDiv = styled.div`
  background: #fefefe;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  border-bottom: solid 2px #f2f2f2;

  &:first-child {
    border-top: solid 2px #f2f2f2;
  }
`

export const RecruitRow = ({
  children,
  ...props
}: React.ComponentProps<typeof StyledDiv>) => {
  return <StyledDiv {...props}>{children}</StyledDiv>
}
